import React from "react";
import { Icon } from "../icon/Icon.jsx";

/* Ringover Tag — rounded label used for call tags / categories.
   Solid filled chips in soft brand tints (e.g. "Close", "CSM USA"). */

const TONES = {
  neutral: { bg: "var(--rg-grey-300)", fg: "var(--text-body)" },
  brand: { bg: "var(--rg-dashboard-500-a08)", fg: "var(--rg-dashboard-700)" },
  purple: { bg: "var(--rg-cadence-500)", fg: "var(--rg-white)" },
  lavender: { bg: "var(--rg-empower-200)", fg: "var(--rg-empower-700)" },
  mint: { bg: "var(--rg-ringover-200)", fg: "var(--rg-green-700)" },
  orange: { bg: "rgb(255,236,214)", fg: "var(--rg-orangeventures-600)" },
  red: { bg: "var(--rg-red-500-a20)", fg: "var(--rg-red-700)" },
};

export function Tag({ children, tone = "neutral", solid, onRemove, style, ...rest }) {
  const t = TONES[tone] || TONES.neutral;
  return (
    <span
      style={{
        display: "inline-flex", alignItems: "center", gap: 6,
        height: 24, padding: onRemove ? "0 6px 0 10px" : "0 10px",
        borderRadius: "var(--radius-pill)",
        background: t.bg, color: t.fg,
        fontFamily: "var(--font-sans)", fontWeight: "var(--weight-medium)",
        fontSize: "var(--text-xs-size)", lineHeight: 1,
        whiteSpace: "nowrap",
        ...style,
      }}
      {...rest}
    >
      {children}
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          aria-label="Remove tag"
          style={{
            display: "inline-flex", alignItems: "center", justifyContent: "center",
            width: 16, height: 16, padding: 0, border: "none",
            borderRadius: "var(--radius-pill)", background: "transparent",
            color: "inherit", cursor: "pointer", opacity: 0.7,
          }}
        >
          <Icon name="x" size={12} strokeWidth={2} />
        </button>
      )}
    </span>
  );
}

export default Tag;
